__turbopack_context__.v({
  "loader": "Spinner-module-scss-module__BRC7pW__loader",
  "prixClipFix": "Spinner-module-scss-module__BRC7pW__prixClipFix",
  "pulse": "Spinner-module-scss-module__BRC7pW__pulse",
  "rotate": "Spinner-module-scss-module__BRC7pW__rotate",
});
